export enum OrderType {
  Ascending = 1,
  Descending = 2,
}
